import { forwardRef, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import UIIcon, { UIIconType } from '@/components/UI/UIIcon'
import UITag from '@/components/UI/UITag'
import { useImageFormatContext } from '@/composables/useImageFormatContext'
import { getContentfulUrl } from '@/utils/contentful'

export type CardProps = {
  variant?: 'top' | 'bottom'
  title: string
  text: string
  type?: string
  tag?: string
  image?: string
  className?: string
  iconClassName?: string
  iconBackground: UIIconType
  iconBackgroundClassName?: string
}

const Card = forwardRef<HTMLDivElement, CardProps>(
  (
    {
      variant = 'top',
      title,
      text,
      tag,
      type,
      className,
      image,
      iconClassName,
      iconBackground,
      iconBackgroundClassName,
    }: CardProps,
    ref
  ) => {
    const { t } = useTranslation()

    const betterFormat = useImageFormatContext()
    const [imageUrl, setImageUrl] = useState(null)
    useEffect(() => {
      if (!image) return
      const url = getContentfulUrl(`/src/assets/runner/${image}.png`, { w: 300, fm: betterFormat })
      setImageUrl(url)
    }, [image, betterFormat])

    return (
      <div
        ref={ref}
        className={`Card relative text-center bg-secondary rounded-80 py-40 px-32 md:px-48 w-252 md:w-[300px] aspect-252/360 md:aspect-30/36 flex ${variant === 'bottom' ? 'flex-col-reverse' : 'flex-col'} ${className ? className : ''}`}
      >
        <div className='absolute inset-0 size-full rounded-80 pointer-events-none overflow-hidden'>
          <UIIcon
            icon={iconBackground}
            className={`absolute pointer-events-none ${variant === 'top' ? '-left-[27px] -bottom-64 text-[240px]' : '-right-[64px] -top-[120px] text-[300px]'}  ${iconBackgroundClassName ? iconBackgroundClassName : ''}`}
          />
        </div>
        {/* <UIIcon icon={icon} className={`absolute pointer-events-none ${variant === 'top' ? 'top-176 left-128 rotate-12' : 'top-48 right-58 -rotate-12'} text-180 ${iconClassName ? iconClassName : ''}`} /> */}

        {image && (
          <img
            src={imageUrl}
            alt={image}
            className={`aspect-square w-1/2 absolute pointer-events-none ${variant === 'top' ? 'bottom-16 left-1/2 -translate-x-1/2 -rotate-12' : 'top-32 left-1/2 -translate-x-1/2 -rotate-12'} ${iconClassName ? iconClassName : ''}`}
          />
        )}

        <div className='relative flex w-full flex-col gap-12'>
          <h2 className='Card__title base-heading text-32 leading-none'>{t(title)}</h2>
          <p className='Card__text text-body'>{t(text)}</p>
        </div>

        {tag && (
          <UITag
            className={`absolute! pointer-events-none text-body py-4 ${variant === 'top' ? '-top-20 left-1/2 -translate-x-1/2' : '-bottom-20 left-1/2 -translate-x-1/2'}`}
            variant='small'
            theme='dark-blue'
          >
            {t(tag)}
          </UITag>
        )}
      </div>
    )
  }
)
export default Card
